import CustomerProfileSimpleForm from './CustomerProfileSimpleForm'

export default CustomerProfileSimpleForm
